
import { useSelector } from "react-redux";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ButtonAdd({ name, onClick }) {

    const stateSize = useSelector((state) => state.size);

    return (

        <>
            {stateSize.desktop != true ? (
                <div className='m-tabbar-container'>
                    <div className="m-tabbar-block-btn-header">
                        <div className='m-tabbar-item first'></div>
                        <button className="m-tabbar-button-menu action" onClick={onClick}>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                    </div>
                </div>
            ) : (
                <div className="tabbar-container">
                    <div className='tabbar-block-btn'>
                        <button className="tabbar-button" onClick={onClick}>
                            <FontAwesomeIcon className="" icon={faPlus} /> {name}
                        </button>
                    </div>
                </div>
            )}
        </>



    )
}
export default ButtonAdd;